/* AORS theme behaviour — cart drawer, mobile menu, product gallery, countdown */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || "en", {
      style: "currency", currency: window.AORS_CURRENCY || "EUR", minimumFractionDigits: 2
    });
  };

  /* ── mobile menu ── */
  var menu = $("#menu");
  function openMenu() { menu.setAttribute("data-open", "true"); $("#openMenu").setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; }
  function closeMenu() { menu.setAttribute("data-open", "false"); $("#openMenu").setAttribute("aria-expanded", "false"); if (drawer.getAttribute("data-open") !== "true") document.body.style.overflow = ""; }
  if (menu) {
    $("#openMenu").addEventListener("click", openMenu);
    $("#closeMenu").addEventListener("click", closeMenu);
  }

  /* ── cart drawer ── */
  var drawer = $("#drawer"), scrim = $("#scrim"), lastFocus = null;
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.setAttribute("data-open", "true");
    scrim.setAttribute("data-open", "true");
    document.body.style.overflow = "hidden";
    var c = $("#closeBag"); if (c) c.focus();
  }
  function closeDrawer() {
    drawer.setAttribute("data-open", "false");
    scrim.setAttribute("data-open", "false");
    document.body.style.overflow = "";
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  if (drawer) {
    $("#openBag").addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
    $("#closeBag").addEventListener("click", closeDrawer);
    scrim.addEventListener("click", closeDrawer);
  }
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (drawer && drawer.getAttribute("data-open") === "true") closeDrawer();
    else if (menu && menu.getAttribute("data-open") === "true") closeMenu();
  });

  /* ── render the drawer from /cart.js ── */
  function drawCart(cart) {
    var count = $("#bagCount"), body = $("#drawerBody"), foot = $("#drawerFoot");
    if (count) count.textContent = cart.item_count;
    if (!body || !foot) return;

    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><img src="' + window.AORS_KNOT + '" alt=""><p style="margin:0">Nothing reserved yet.</p></div>';
      foot.innerHTML = '<a class="btn btn--block" href="' + window.AORS_SHOP_URL + '">Go to the shop</a>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : window.AORS_KNOT;
      var opts = item.options_with_values
        ? item.options_with_values.map(function (o) { return o.value; }).join(" \u00B7 ")
        : "";
      return '<div class="line"><span class="line__img"><img src="' + img + '" alt=""></span>' +
        '<div><p class="line__t">' + item.product_title + '</p>' +
        '<p class="line__m">' + (opts ? opts + " \u00B7 " : "") + "Qty " + item.quantity + '</p>' +
        '<button class="line__x" data-key="' + item.key + '">Remove</button></div>' +
        '<span class="line__p">' + money(item.final_line_price) + "</span></div>";
    }).join("");

    $$("[data-key]", body).forEach(function (b) {
      b.addEventListener("click", function () { changeLine(b.dataset.key, 0); });
    });

    foot.innerHTML =
      '<div class="sum"><span>Subtotal</span><b>' + money(cart.items_subtotal_price) + "</b></div>" +
      '<div class="sum"><span>Shipping</span><b>Calculated at checkout</b></div>' +
      '<div class="sum sum--tot"><span>Total</span><b>' + money(cart.total_price) + "</b></div>" +
      '<a class="btn btn--block" href="/checkout">Checkout</a>' +
      '<p class="note"><a href="/cart" style="text-decoration:underline">View the full bag</a></p>';
  }

  function refresh(open) {
    return fetch(window.Shopify.routes.root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { drawCart(cart); if (open) openDrawer(); return cart; })
      .catch(function () { });
  }

  function changeLine(key, qty) {
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        drawCart(cart);
        if (document.body.classList.contains("template-cart")) window.location.reload();
      });
  }

  /* ── add to cart from the product form ── */
  var form = $("#addToCartForm");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $("#addToCart", form), note = $("#buyNote");
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = "Adding\u2026";
      fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btn.disabled = false;
          btn.textContent = original;
          if (!res.ok) {
            if (note) note.textContent = res.data.description || "That size is not available.";
            return;
          }
          refresh(true);
        })
        .catch(function () { btn.disabled = false; btn.textContent = original; });
    });

    /* variant picker → price, availability, hidden id */
    var variants = window.AORS_VARIANTS || [];
    function syncVariant() {
      var checked = $("input[name='aors-option']:checked", form);
      if (!checked) return;
      var v = variants.filter(function (x) { return String(x.id) === checked.value; })[0];
      if (!v) return;
      $("#variantId", form).value = v.id;
      var price = $("#pdpPrice");
      if (price) price.textContent = money(v.price);
      var btn = $("#addToCart", form);
      btn.disabled = !v.available;
      btn.textContent = v.available ? (window.AORS_CTA || "Add to bag") : "Sold out";
      var note = $("#buyNote");
      if (note && v.available && v.inventory_quantity && v.inventory_quantity > 0 && v.inventory_quantity < 12) {
        note.textContent = v.inventory_quantity + " left in " + v.title + " for this run.";
      } else if (note) {
        note.textContent = window.AORS_NOTE || "";
      }
    }
    $$("input[name='aors-option']", form).forEach(function (i) { i.addEventListener("change", syncVariant); });
    syncVariant();

    var qtyIn = $("#qty", form);
    if (qtyIn) {
      $("#qMinus", form).addEventListener("click", function () { qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) - 1); });
      $("#qPlus", form).addEventListener("click", function () { qtyIn.value = Math.min(10, (parseInt(qtyIn.value, 10) || 1) + 1); });
    }
  }

  /* ── product gallery ── */
  var thumbs = $("#thumbs");
  if (thumbs) {
    thumbs.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      var main = $("#galImg"), cap = $("#galCap");
      main.src = b.dataset.full;
      main.alt = b.dataset.alt || "";
      if (cap) cap.textContent = b.dataset.cap || "";
      $$("button", thumbs).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
    });
  }

  /* ── cart page quantity + remove ── */
  $$("[data-cart-change]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      changeLine(el.dataset.key, parseInt(el.dataset.qty, 10));
    });
  });

  /* ── countdown ── */
  var clock = $("#clock");
  if (clock && clock.dataset.deadline) {
    var end = new Date(clock.dataset.deadline);
    (function tick() {
      var ms = end - new Date();
      if (isNaN(ms)) { clock.style.display = "none"; return; }
      if (ms <= 0) {
        clock.innerHTML = '<div style="min-width:auto;padding:14px 20px"><b style="font-size:20px">Window closed</b></div>';
        return;
      }
      var s = Math.floor(ms / 1000), pad = function (n) { return String(n).padStart(2, "0"); };
      $("#cd-d").textContent = Math.floor(s / 86400);
      $("#cd-h").textContent = pad(Math.floor((s % 86400) / 3600));
      $("#cd-m").textContent = pad(Math.floor((s % 3600) / 60));
      $("#cd-s").textContent = pad(s % 60);
      setTimeout(tick, 1000);
    })();
  }

  if (drawer) refresh(false);
})();
